import { Reducer } from "redux";
import * as actions from "./partnershipActions";
import produce from "immer";
import { Partnership } from "../../service/api-response/PartnershipListSuccessResponse";
import { AdminErrorListResponseData } from "../../service/api-response/AdminFormErrorResponse";

export interface PartnershipState {
  partnershipsByOrg: {
    [orgKeyName: string]: undefined | Partnership[];
  };
  partnership: {
    [orgKeyName: string]: undefined | Partnership;
  };
  isLoadingPartnershipsByOrg: {
    [orgKeyName: string]: undefined | boolean;
  };
  isLoading: {
    [orgKeyName: string]: undefined | boolean;
  };
  isUpserting: boolean;
  upsertErrors: AdminErrorListResponseData | undefined;
}

const initialState: PartnershipState = {
  partnershipsByOrg: {},
  partnership: {},
  isLoadingPartnershipsByOrg: {},
  isLoading: {},
  isUpserting: false,
  upsertErrors: undefined,
};

type SupportedActions =
  | actions.ListAction
  | actions.ListFailAction
  | actions.ListSuccessAction;

export const partnershipReducer: Reducer<PartnershipState, SupportedActions> = (
  state = initialState,
  action
): PartnershipState => {
  return produce(state, (draftState) => {
    switch (action.type) {
      case actions.LIST: {
        draftState.isLoadingPartnershipsByOrg[action.organization] = true;
        break;
      }
      case actions.LIST_FAIL: {
        draftState.isLoadingPartnershipsByOrg[action.organization] = false;
        break;
      }
      case actions.LIST_SUCCESS: {
        draftState.isLoadingPartnershipsByOrg[action.organization] = false;
        draftState.partnershipsByOrg[action.organization] = action.data;
        break;
      }
      default: {
        return;
      }
    }
  });
};
